export const CONFIRM_BUTTON_OPTIONS: Record<string, string[]> = {
    "en-US": [
        "Proceed to Checkout",
        "Finalize Your Order",
        "Let's Make It Official",
        "Take My Money!",
        "Buy Now",
        "Finish Order",
        "Continue",
        "Pay",
        "Yay! Let's Buy It",
        "Gimme That!",
        "Make It Mine",
        "Get It Now",
        "Lock It In",
        "You're Almost There!",
    ],
    "en-GB": [
        "Proceed to Checkout",
        "Go to Checkout",
        "Complete Purchase",
        "Buy Now",
        "Finish Order",
        "Continue",
        "Pay Now",
    ],
    "es-ES": [
        "Ir a la caja",
        "Finalizar compra",
        "Proceder al pago",
        "Comprar ahora",
        "Terminar pedido",
        "Continuar",
        "Pagar ahora",
    ],
    "es-MX": [
        "Ir a pagar",
        "Finalizar compra",
        "Proceder al pago",
        "Comprar ahora",
        "Terminar pedido",
        "Continuar",
        "Pagar ahora",
    ],
    "fr-FR": [
        "Passer au paiement",
        "Finaliser la commande",
        "Aller au paiement",
        "Acheter maintenant",
        "Terminer la commande",
        "Continuer",
        "Payer maintenant",
    ],
    "fr-CA": [
        "Passer au paiement",
        "Finaliser la commande",
        "Aller au paiement",
        "Acheter maintenant",
        "Terminer la commande",
        "Continuer",
        "Payer maintenant",
    ],
    "de-DE": [
        "Zur Kasse",
        "Bestellung abschließen",
        "Zum Bezahlen",
        "Jetzt kaufen",
        "Weiter",
        "Jetzt bezahlen",
    ],
    "it-IT": [
        "Procedi al checkout",
        "Concludi l’ordine",
        "Vai alla cassa",
        "Acquista ora",
        "Continua",
        "Paga ora",
    ],
    "pt-PT": [
        "Ir para o checkout",
        "Finalizar compra",
        "Prosseguir para pagamento",
        "Comprar agora",
        "Concluir pedido",
        "Pagar agora",
    ],
    "pt-BR": [
        "Ir para o checkout",
        "Finalizar pedido",
        "Prosseguir para pagamento",
        "Comprar agora",
        "Concluir pedido",
        "Pagar agora",
    ],
    "nl-NL": [
        "Ga naar afrekenen",
        "Bestelling afronden",
        "Afrekenen",
        "Nu kopen",
        "Doorgaan",
        "Nu betalen",
    ],
    "da-DK": [
        "Gå til kassen",
        "Afslut køb",
        "Gå til betaling",
        "Køb nu",
        "Fortsæt",
        "Betal nu",
    ],
    "sv-SE": [
        "Gå till kassan",
        "Slutför köp",
        "Gå till betalning",
        "Köp nu",
        "Fortsätt",
        "Betala nu",
    ],
    "no-NO": [
        "Gå til kassen",
        "Fullfør kjøp",
        "Gå til betaling",
        "Kjøp nå",
        "Fortsett",
        "Betal nå",
    ],
    "fi-FI": [
        "Siirry kassalle",
        "Viimeistele tilaus",
        "Siirry maksamaan",
        "Osta nyt",
        "Jatka",
        "Maksa nyt",
    ],
    "pl-PL": [
        "Przejdź do kasy",
        "Zakończ zamówienie",
        "Przejdź do płatności",
        "Kup teraz",
        "Kontynuuj",
        "Zapłać teraz",
    ],
    "tr-TR": [
        "Ödeme sayfasına geç",
        "Siparişi tamamla",
        "Ödemeye devam et",
        "Şimdi satın al",
        "Devam et",
        "Şimdi öde",
    ],
    "ru-RU": [
        "Перейти к оформлению",
        "Завершить заказ",
        "Перейти к оплате",
        "Купить сейчас",
        "Продолжить",
        "Оплатить сейчас",
    ],
    "ar-SA": [
        "الانتقال إلى الدفع",
        "إتمام الطلب",
        "المتابعة للدفع",
        "اشترِ الآن",
        "متابعة",
        "ادفع الآن",
    ],
    "he-IL": [
        "השלמת רכישה",
        "המשיכו לעגלה",
        "מעבר לתשלום",
        "שנו את החיים!",
        "רוצה את זה עכשיו",
        "יאללה, רוצה לקנות",
        "לקופה וסיימנו",
        "תביא לי את זה",
        // a couple of standard options too:
        "סיום הזמנה",
        "המשך לתשלום",
    ],
    "zh-CN": [
        "前往结账",
        "完成下单",
        "去付款",
        "立即购买",
        "继续",
        "立即支付",
        "去结算",
    ],
    "zh-TW": [
        "前往結帳",
        "完成下單",
        "前往付款",
        "立即購買",
        "繼續",
        "立即付款",
        "去結帳",
    ],
    "ja-JP": [
        "レジに進む",
        "購入手続きへ",
        "お支払いへ進む",
        "今すぐ購入",
        "続行",
        "今すぐ支払う",
        "注文を確定",
    ],
    "ko-KR": [
        "결제하기로 이동",
        "주문 완료하기",
        "결제 단계로 이동",
        "지금 구매",
        "계속",
        "지금 결제",
        "주문 확정",
    ],
    "hi-IN": [
        "चेकआउट पर जाएँ",
        "ऑर्डर पूरा करें",
        "भुगतान के लिए आगे बढ़ें",
        "अभी खरीदें",
        "जारी रखें",
        "अभी भुगतान करें",
        "ऑर्डर की पुष्टि करें",
    ],
    "th-TH": [
        "ไปที่ชำระเงิน",
        "สั่งซื้อให้เสร็จ",
        "ไปยังการชำระเงิน",
        "ซื้อเลย",
        "ดำเนินการต่อ",
        "ชำระเงินตอนนี้",
    ],
    "vi-VN": [
        "Tiến hành thanh toán",
        "Hoàn tất đơn hàng",
        "Đi đến thanh toán",
        "Mua ngay",
        "Tiếp tục",
        "Thanh toán ngay",
    ],
    "id-ID": [
        "Lanjut ke pembayaran",
        "Selesaikan pesanan",
        "Masuk ke pembayaran",
        "Beli sekarang",
        "Lanjutkan",
        "Bayar sekarang",
    ],
    "ms-MY": [
        "Teruskan ke pembayaran",
        "Selesaikan pesanan",
        "Pergi ke pembayaran",
        "Beli sekarang",
        "Teruskan",
        "Bayar sekarang",
    ],
    "el-GR": [
        "Μετάβαση στο ταμείο",
        "Ολοκλήρωση παραγγελίας",
        "Μετάβαση στην πληρωμή",
        "Αγορά τώρα",
        "Συνέχεια",
        "Πληρωμή τώρα",
    ],
    "cs-CZ": [
        "Přejít k pokladně",
        "Dokončit objednávku",
        "Přejít k platbě",
        "Koupit nyní",
        "Pokračovat",
        "Zaplatit nyní",
    ],
    "hu-HU": [
        "Tovább a pénztárhoz",
        "Rendelés befejezése",
        "Tovább a fizetéshez",
        "Vásárlás most",
        "Folytatás",
        "Fizetés most",
    ],
    "ro-RO": [
        "Mergi la plată",
        "Finalizează comanda",
        "Continuă la plată",
        "Cumpără acum",
        "Continuă",
        "Plătește acum",
    ],
    "sk-SK": [
        "Prejsť k pokladni",
        "Dokončiť objednávku",
        "Prejsť k platbe",
        "Kúpiť teraz",
        "Pokračovať",
        "Zaplatiť teraz",
    ],
    "uk-UA": [
        "Перейти до оплати",
        "Завершити замовлення",
        "Перейти до оформлення",
        "Купити зараз",
        "Продовжити",
        "Сплатити зараз",
    ],
    "bg-BG": [
        "Към плащане",
        "Завърши поръчката",
        "Продължи към плащане",
        "Купи сега",
        "Продължи",
        "Плати сега",
    ],
};
